import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { logger } from '@zep/core-logger';
/**
 * useUpgradePlanHandler - 플랜 업그레이드 핸들러
 *
 * @description
 * 가격 정책 페이지로 이동하여 플랜 업그레이드를 유도합니다.
 */
export const useUpgradePlanHandler = () => {
  const router = useRouter();

  return useCallback(() => {
    void router.push('/pricing');
    logger.track('plan_upgrade_click', {
      location: 'detail_locked_quiz',
    });
  }, [router]);
};
